/**
 * Antd static function provider for use outside React components.
 * Pattern: https://ant.design/components/app#global-scene-redux
 */
import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

let message: MessageInstance;
let notification: NotificationInstance;
let modal: Omit<ModalStaticFunctions, 'warn'>;

/** 在 App 上下文内渲染此组件完成初始化，无 DOM 输出 */
const AntdStaticInit = () => {
  const staticFunction = App.useApp();
  message = staticFunction.message;
  modal = staticFunction.modal;
  notification = staticFunction.notification;
  return null;
};

export { AntdStaticInit, message, modal, notification };
